"use client";

import Link from "next/link";
import { useFormStatus } from "react-dom";
import { login } from "@/app/actions";
import { useAccountSession } from "@/providers/account-session";
import { SaveButtonSpinner } from "@/components/save-button-spinner";

function Arrow() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      aria-hidden="true"
    >
      <path className="portal-home-sign-in-line" d="M0 5h7" />
      <path className="portal-home-sign-in-tip" d="m1 1 4 4-4 4" />
    </svg>
  );
}

function SignIn() {
  const { pending } = useFormStatus();
  return (
    <div className="flex items-center">
      <button
        type="submit"
        className="portal-home-sign-in"
        disabled={pending}
        aria-busy={pending}
      >
        Sign in <Arrow />
      </button>
      <SaveButtonSpinner show={pending} />
    </div>
  );
}

export function HomeAccountAction() {
  const { session, resolving } = useAccountSession();
  return (
    <div className="portal-home-sign-in-form mt-6 min-h-10">
      {session?.token ? (
        <Link href="/settings/subscriptions" className="portal-home-sign-in">
          Go to Subscriptions <Arrow />
        </Link>
      ) : resolving ? null : (
        <form action={login}>
          <SignIn />
        </form>
      )}
    </div>
  );
}
